// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"d8ec7ca8","219":"90c96837","426":"d8b119a8","428":"b92d632e","453":"e5407da2","494":"b58de680","547":"750e51f1","874":"6970eb95","889":"d80cb64b"}[chunkId] + ".chunk.js";
};